import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Question as QuestionType, AnswerOption } from '../../types';
import AnswerOptionComponent from './AnswerOption';

interface QuestionProps {
  question: QuestionType;
  options: AnswerOption[];
  onAnswer: (answerId: string, value?: string | number | Date) => void;
  selectedAnswer?: string;
}

export default function Question({ question, options, onAnswer, selectedAnswer }: QuestionProps) {
  const { i18n } = useTranslation();
  const isSpanish = i18n.language === 'es';

  const questionText = isSpanish && question.questionTextEs
    ? question.questionTextEs
    : question.questionText;

  const handleSelect = (optionId: string) => {
    onAnswer(optionId);
  };

  return (
    <div className="animate-fade-in">
      {/* Question Text */}
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">
        {questionText}
      </h2>

      {/* Help Text */}
      {question.helpText && (
        <p className="text-gray-600 mb-6">
          {question.helpText}
        </p>
      )}

      {/* Answer Options */}
      <div className="space-y-3 mt-6">
        {options.map(option => (
          <AnswerOptionComponent
            key={option.id}
            option={option}
            isSelected={selectedAnswer === option.id}
            onSelect={handleSelect}
          />
        ))}
      </div>

      {/* Required indicator */}
      {question.isRequired && (
        <p className="text-sm text-gray-500 mt-4">
          * This question is required
        </p>
      )}
    </div>
  );
}
